export const PATH_ID = 'id';
export const ITEM_ID = 'id';
export const PATH_MODIFIED_DATE = 'modifiedDate';
export const ITEM_MODIFIED_DATE = 'modifiedDate';
export const PATH_VERTRAGS_AENDERUNG = 'vertragsAenderung';
export const ITEM_VERTRAGS_AENDERUNG = 'vertragsAenderung';
export const PATH_VERTRAGSZUSTAND_PER_DATUM = 'vertragszustandPerDatum';
export const ITEM_VERTRAGSZUSTAND_PER_DATUM = 'vertragszustandPerDatum';
export const PATH_VERTRAGS_AENDERUNG_INITIALISIERT = 'vertragsAenderungInitialisiert';
export const ITEM_VERTRAGS_AENDERUNG_INITIALISIERT = 'vertragsAenderungInitialisiert';
export const PATH_IDD_BERATUNG_DURCHGEFUEHRT = 'iddBeratungDurchgefuehrt';
export const ITEM_IDD_BERATUNG_DURCHGEFUEHRT = 'iddBeratungDurchgefuehrt';
export const PATH_VERTRAGS_NUMMER = 'vertragsNummer';
export const ITEM_VERTRAGS_NUMMER = 'vertragsNummer';
export const PATH_VERSIONS_NUMMER = 'versionsNummer';
export const ITEM_VERSIONS_NUMMER = 'versionsNummer';
export const PATH_VERTRAGS_ABLAUF_DATUM = 'vertragsAblaufDatum';
export const ITEM_VERTRAGS_ABLAUF_DATUM = 'vertragsAblaufDatum';
export const PATH_PRODUKT = 'produkt';
export const ITEM_PRODUKT = 'produkt';
export const PATH_FZ_KONTO = 'fzKonto';
export const ITEM_FZ_KONTO = 'fzKonto';
export const PATH_FZ_KONTO_KONTO = 'fzKonto.konto';
export const ITEM_FZ_KONTO_KONTO = 'konto';
export const PATH_FZ_KONTO_KONTO_NAME = 'fzKonto.kontoName';
export const ITEM_FZ_KONTO_KONTO_NAME = 'kontoName';
export const PATH_FZ_KONTO_EXKLUSIV_ABBER_NR = 'fzKonto.exklusivAbberNr';
export const ITEM_FZ_KONTO_EXKLUSIV_ABBER_NR = 'exklusivAbberNr';
export const PATH_FZ_KONTO_VERRECHNUNGSART = 'fzKonto.verrechnungsart';
export const ITEM_FZ_KONTO_VERRECHNUNGSART = 'verrechnungsart';
export const PATH_FZ_KONTO_BEZEICHNUNG = 'fzKonto.bezeichnung';
export const ITEM_FZ_KONTO_BEZEICHNUNG = 'bezeichnung';
export const PATH_FZ_KONTO_GILT_VON = 'fzKonto.giltVon';
export const ITEM_FZ_KONTO_GILT_VON = 'giltVon';
export const PATH_FZ_KONTO_GILT_BIS = 'fzKonto.giltBis';
export const ITEM_FZ_KONTO_GILT_BIS = 'giltBis';
export const PATH_FZ_KONTO_PERSONAL_NUMMER_REGEX = 'fzKonto.personalNummerRegex';
export const ITEM_FZ_KONTO_PERSONAL_NUMMER_REGEX = 'personalNummerRegex';
export const PATH_FZ_KONTO_PERSONAL_NUMMER_EXPLANATION = 'fzKonto.personalNummerExplanation';
export const ITEM_FZ_KONTO_PERSONAL_NUMMER_EXPLANATION = 'personalNummerExplanation';
export const PATH_FZ_KONTO_DIENSTSTELLE_REQUIRED = 'fzKonto.dienststelleRequired';
export const ITEM_FZ_KONTO_DIENSTSTELLE_REQUIRED = 'dienststelleRequired';
export const PATH_FZ_KONTO_PERS_NR_ERFORDERLICH = 'fzKonto.persNrErforderlich';
export const ITEM_FZ_KONTO_PERS_NR_ERFORDERLICH = 'persNrErforderlich';
export const PATH_BESTAND_FZ_KONTO_NR = 'bestandFzKontoNr';
export const ITEM_BESTAND_FZ_KONTO_NR = 'bestandFzKontoNr';
export const PATH_SV_VERMITTLER_INFO = 'vermittlerInfo';
export const ITEM_SV_VERMITTLER_INFO = 'vermittlerInfo';
export const PATH_SV_VERMITTLER_INFO_VERMITTLER_NR = 'vermittlerInfo.vermittlerNr';
export const ITEM_SV_VERMITTLER_INFO_VERMITTLER_NR = 'vermittlerNr';
export const PATH_SV_VERMITTLER_INFO_VERMITTLER_NAME = 'vermittlerInfo.vermittlerName';
export const ITEM_SV_VERMITTLER_INFO_VERMITTLER_NAME = 'vermittlerName';
export const PATH_SV_VERMITTLER_INFO_VERMITTLER_NAME_NACHNAME = 'vermittlerInfo.vermittlerName.nachname';
export const ITEM_SV_VERMITTLER_INFO_VERMITTLER_NAME_NACHNAME = 'nachname';
export const PATH_SV_VERMITTLER_INFO_VERMITTLER_NAME_VORNAME = 'vermittlerInfo.vermittlerName.vorname';
export const ITEM_SV_VERMITTLER_INFO_VERMITTLER_NAME_VORNAME = 'vorname';
export const PATH_SV_VERMITTLER_INFO_MAKLER = 'vermittlerInfo.makler';
export const ITEM_SV_VERMITTLER_INFO_MAKLER = 'makler';
export const PATH_SV_VERMITTLER_INFO_COURTAGE = 'vermittlerInfo.courtage';
export const ITEM_SV_VERMITTLER_INFO_COURTAGE = 'courtage';
export const PATH_SV_VERMITTLER_INFO_HAS_GV = 'vermittlerInfo.hasGv';
export const ITEM_SV_VERMITTLER_INFO_HAS_GV = 'hasGv';
export const PATH_SV_VERMITTLER_INFO_HAS_LV = 'vermittlerInfo.hasLv';
export const ITEM_SV_VERMITTLER_INFO_HAS_LV = 'hasLv';
export const PATH_SV_VERMITTLER_INFO_HAS_SV = 'vermittlerInfo.hasSv';
export const ITEM_SV_VERMITTLER_INFO_HAS_SV = 'hasSv';
export const PATH_SV_VERMITTLER_INFO_HAS_UV = 'vermittlerInfo.hasUv';
export const ITEM_SV_VERMITTLER_INFO_HAS_UV = 'hasUv';
export const PATH_SV_VERMITTLER_INFO_VSE_REQUIRED = 'vermittlerInfo.vseRequired';
export const ITEM_SV_VERMITTLER_INFO_VSE_REQUIRED = 'vseRequired';
export const PATH_SV_VERMITTLER_INFO_KOOPERATIONSPARTNER = 'vermittlerInfo.kooperationspartner';
export const ITEM_SV_VERMITTLER_INFO_KOOPERATIONSPARTNER = 'kooperationspartner';
export const PATH_SV_VERMITTLER_INFO_ABKOMMEN = 'vermittlerInfo.abkommen';
export const ITEM_SV_VERMITTLER_INFO_ABKOMMEN = 'abkommen';
export const PATH_SV_VERMITTLER_INFO_ABBER_TYPE = 'vermittlerInfo.abberType';
export const ITEM_SV_VERMITTLER_INFO_ABBER_TYPE = 'abberType';
export const PATH_SV_VERMITTLER_INFO_IS_MAKLERSPITZE = 'vermittlerInfo.isMaklerspitze';
export const ITEM_SV_VERMITTLER_INFO_IS_MAKLERSPITZE = 'isMaklerspitze';
export const PATH_SV_VERMITTLER_INFO_IS_TEAM_PARTNER_SPITZE = 'vermittlerInfo.isTeamPartnerSpitze';
export const ITEM_SV_VERMITTLER_INFO_IS_TEAM_PARTNER_SPITZE = 'isTeamPartnerSpitze';
export const PATH_SV_VERMITTLER_INFO_HAS_DISPLAYABLE_SUBORDINATES = 'vermittlerInfo.hasDisplayableSubordinates';
export const ITEM_SV_VERMITTLER_INFO_HAS_DISPLAYABLE_SUBORDINATES = 'hasDisplayableSubordinates';
export const PATH_SV_VERMITTLER_INFO_BLATT_ABBER = 'vermittlerInfoBlattAbber';
export const ITEM_SV_VERMITTLER_INFO_BLATT_ABBER = 'vermittlerInfoBlattAbber';
export const PATH_SV_VERMITTLER_INFO_BLATT_ABBER_VERMITTLER_NR = 'vermittlerInfoBlattAbber.vermittlerNr';
export const ITEM_SV_VERMITTLER_INFO_BLATT_ABBER_VERMITTLER_NR = 'vermittlerNr';
export const PATH_SV_VERMITTLER_INFO_BLATT_ABBER_VERMITTLER_NAME = 'vermittlerInfoBlattAbber.vermittlerName';
export const ITEM_SV_VERMITTLER_INFO_BLATT_ABBER_VERMITTLER_NAME = 'vermittlerName';
export const PATH_SV_VERMITTLER_INFO_BLATT_ABBER_VERMITTLER_NAME_NACHNAME =
  'vermittlerInfoBlattAbber.vermittlerName.nachname';
export const ITEM_SV_VERMITTLER_INFO_BLATT_ABBER_VERMITTLER_NAME_NACHNAME = 'nachname';
export const PATH_SV_VERMITTLER_INFO_BLATT_ABBER_VERMITTLER_NAME_VORNAME =
  'vermittlerInfoBlattAbber.vermittlerName.vorname';
export const ITEM_SV_VERMITTLER_INFO_BLATT_ABBER_VERMITTLER_NAME_VORNAME = 'vorname';
export const PATH_SV_VERMITTLER_INFO_BLATT_ABBER_MAKLER = 'vermittlerInfoBlattAbber.makler';
export const ITEM_SV_VERMITTLER_INFO_BLATT_ABBER_MAKLER = 'makler';
export const PATH_SV_VERMITTLER_INFO_BLATT_ABBER_COURTAGE = 'vermittlerInfoBlattAbber.courtage';
export const ITEM_SV_VERMITTLER_INFO_BLATT_ABBER_COURTAGE = 'courtage';
export const PATH_SV_VERMITTLER_INFO_BLATT_ABBER_HAS_GV = 'vermittlerInfoBlattAbber.hasGv';
export const ITEM_SV_VERMITTLER_INFO_BLATT_ABBER_HAS_GV = 'hasGv';
export const PATH_SV_VERMITTLER_INFO_BLATT_ABBER_HAS_LV = 'vermittlerInfoBlattAbber.hasLv';
export const ITEM_SV_VERMITTLER_INFO_BLATT_ABBER_HAS_LV = 'hasLv';
export const PATH_SV_VERMITTLER_INFO_BLATT_ABBER_HAS_SV = 'vermittlerInfoBlattAbber.hasSv';
export const ITEM_SV_VERMITTLER_INFO_BLATT_ABBER_HAS_SV = 'hasSv';
export const PATH_SV_VERMITTLER_INFO_BLATT_ABBER_HAS_UV = 'vermittlerInfoBlattAbber.hasUv';
export const ITEM_SV_VERMITTLER_INFO_BLATT_ABBER_HAS_UV = 'hasUv';
export const PATH_SV_VERMITTLER_INFO_BLATT_ABBER_VSE_REQUIRED = 'vermittlerInfoBlattAbber.vseRequired';
export const ITEM_SV_VERMITTLER_INFO_BLATT_ABBER_VSE_REQUIRED = 'vseRequired';
export const PATH_SV_VERMITTLER_INFO_BLATT_ABBER_KOOPERATIONSPARTNER = 'vermittlerInfoBlattAbber.kooperationspartner';
export const ITEM_SV_VERMITTLER_INFO_BLATT_ABBER_KOOPERATIONSPARTNER = 'kooperationspartner';
export const PATH_SV_VERMITTLER_INFO_BLATT_ABBER_ABKOMMEN = 'vermittlerInfoBlattAbber.abkommen';
export const ITEM_SV_VERMITTLER_INFO_BLATT_ABBER_ABKOMMEN = 'abkommen';
export const PATH_SV_VERMITTLER_INFO_BLATT_ABBER_ABBER_TYPE = 'vermittlerInfoBlattAbber.abberType';
export const ITEM_SV_VERMITTLER_INFO_BLATT_ABBER_ABBER_TYPE = 'abberType';
export const PATH_SV_VERMITTLER_INFO_BLATT_ABBER_IS_MAKLERSPITZE = 'vermittlerInfoBlattAbber.isMaklerspitze';
export const ITEM_SV_VERMITTLER_INFO_BLATT_ABBER_IS_MAKLERSPITZE = 'isMaklerspitze';
export const PATH_SV_VERMITTLER_INFO_BLATT_ABBER_IS_TEAM_PARTNER_SPITZE =
  'vermittlerInfoBlattAbber.isTeamPartnerSpitze';
export const ITEM_SV_VERMITTLER_INFO_BLATT_ABBER_IS_TEAM_PARTNER_SPITZE = 'isTeamPartnerSpitze';
export const PATH_SV_VERMITTLER_INFO_BLATT_ABBER_HAS_DISPLAYABLE_SUBORDINATES =
  'vermittlerInfoBlattAbber.hasDisplayableSubordinates';
export const ITEM_SV_VERMITTLER_INFO_BLATT_ABBER_HAS_DISPLAYABLE_SUBORDINATES = 'hasDisplayableSubordinates';
export const PATH_RISIKO_ADRESSE_NOTWENDIG = 'risikoAdresseNotwendig';
export const ITEM_RISIKO_ADRESSE_NOTWENDIG = 'risikoAdresseNotwendig';
export const PATH_RISIKO_ADRESSE = 'risikoAdresse';
export const ITEM_RISIKO_ADRESSE = 'risikoAdresse';
export const PATH_RISIKO_ADRESSE_STRASSE = 'risikoAdresse.strasse';
export const ITEM_RISIKO_ADRESSE_STRASSE = 'strasse';
export const PATH_RISIKO_ADRESSE_HAUSNR = 'risikoAdresse.hausnr';
export const ITEM_RISIKO_ADRESSE_HAUSNR = 'hausnr';
export const PATH_RISIKO_ADRESSE_IKZ = 'risikoAdresse.ikz';
export const ITEM_RISIKO_ADRESSE_IKZ = 'ikz';
export const PATH_RISIKO_ADRESSE_ORT = 'risikoAdresse.ort';
export const ITEM_RISIKO_ADRESSE_ORT = 'ort';
export const PATH_RISIKO_ADRESSE_PLZ = 'risikoAdresse.plz';
export const ITEM_RISIKO_ADRESSE_PLZ = 'plz';
export const PATH_RISIKO_ADRESSE_CHECK_STATE = 'risikoAdresse.checkState';
export const ITEM_RISIKO_ADRESSE_CHECK_STATE = 'checkState';
export const PATH_BERATUNGSDATEN = 'beratungsdaten';
export const ITEM_BERATUNGSDATEN = 'beratungsdaten';
export const PATH_BERATUNGSDATEN_PRODUKT_KATEGORIE = 'beratungsdaten.produktKategorie';
export const ITEM_BERATUNGSDATEN_PRODUKT_KATEGORIE = 'produktKategorie';
export const PATH_BERATUNGSDATEN_PRODUKT_NUMMER = 'beratungsdaten.produktNummer';
export const ITEM_BERATUNGSDATEN_PRODUKT_NUMMER = 'produktNummer';
export const PATH_BERATUNGSDATEN_ZWEIGE = 'beratungsdaten.zweige';
export const ITEM_BERATUNGSDATEN_ZWEIGE = 'zweige';
export const PATH_BERATUNGSDATEN_ZWEIGE_ID = 'beratungsdaten.zweige.id';
export const ITEM_BERATUNGSDATEN_ZWEIGE_ID = 'id';
export const PATH_BERATUNGSDATEN_ZWEIGE_LEISTUNGSARTEN = 'beratungsdaten.zweige.leistungsarten';
export const ITEM_BERATUNGSDATEN_ZWEIGE_LEISTUNGSARTEN = 'leistungsarten';
export const PATH_BERATUNGSDATEN_ZWEIGE_LEISTUNGSARTEN_ID = 'beratungsdaten.zweige.leistungsarten.id';
export const ITEM_BERATUNGSDATEN_ZWEIGE_LEISTUNGSARTEN_ID = 'id';
export const PATH_SV_PERSONEN_DATA = 'svPersonenData';
export const ITEM_SV_PERSONEN_DATA = 'svPersonenData';
export const PATH_SV_PERSONEN_DATA_PERSONEN = 'svPersonenData.personen';
export const ITEM_SV_PERSONEN_DATA_PERSONEN = 'personen';
export const PATH_SV_PERSONEN_DATA_PERSONEN_ID = 'svPersonenData.personen.id';
export const ITEM_SV_PERSONEN_DATA_PERSONEN_ID = 'id';
export const PATH_SV_PERSONEN_DATA_PERSONEN_HAUPTWOHNSITZ_OESTERREICH =
  'svPersonenData.personen.hauptwohnsitzOesterreich';
export const ITEM_SV_PERSONEN_DATA_PERSONEN_HAUPTWOHNSITZ_OESTERREICH = 'hauptwohnsitzOesterreich';
export const PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN = 'svPersonenData.personen.stammdaten';
export const ITEM_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN = 'stammdaten';
export const PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_PARTNER_NR = 'svPersonenData.personen.stammdaten.partnerNr';
export const ITEM_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_PARTNER_NR = 'partnerNr';
export const PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_GESCHLECHT = 'svPersonenData.personen.stammdaten.geschlecht';
export const ITEM_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_GESCHLECHT = 'geschlecht';
export const PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_VORNAME = 'svPersonenData.personen.stammdaten.vorname';
export const ITEM_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_VORNAME = 'vorname';
export const PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_TITEL = 'svPersonenData.personen.stammdaten.titel';
export const ITEM_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_TITEL = 'titel';
export const PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_TITEL_NACHGESTELLT =
  'svPersonenData.personen.stammdaten.titelNachgestellt';
export const ITEM_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_TITEL_NACHGESTELLT = 'titelNachgestellt';
export const PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_BERUFSTITEL = 'svPersonenData.personen.stammdaten.berufstitel';
export const ITEM_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_BERUFSTITEL = 'berufstitel';
export const PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_TIME_STAMP = 'svPersonenData.personen.stammdaten.timeStamp';
export const ITEM_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_TIME_STAMP = 'timeStamp';
export const PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_NAME = 'svPersonenData.personen.stammdaten.name';
export const ITEM_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_NAME = 'name';
export const PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_GEBDATUM = 'svPersonenData.personen.stammdaten.gebdatum';
export const ITEM_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_GEBDATUM = 'gebdatum';
export const PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_FAMILIENSTAND =
  'svPersonenData.personen.stammdaten.familienstand';
export const ITEM_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_FAMILIENSTAND = 'familienstand';
export const PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_BERUFSBEZEICHNUNG =
  'svPersonenData.personen.stammdaten.berufsbezeichnung';
export const ITEM_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_BERUFSBEZEICHNUNG = 'berufsbezeichnung';
export const PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_BESCHAEFTIGUNGSART =
  'svPersonenData.personen.stammdaten.beschaeftigungsart';
export const ITEM_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_BESCHAEFTIGUNGSART = 'beschaeftigungsart';
export const PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_BESCHAEFTIGT_BEI =
  'svPersonenData.personen.stammdaten.beschaeftigtBei';
export const ITEM_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_BESCHAEFTIGT_BEI = 'beschaeftigtBei';
export const PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_GEBURTSLAND = 'svPersonenData.personen.stammdaten.geburtsland';
export const ITEM_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_GEBURTSLAND = 'geburtsland';
export const PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_NATIONALITAET =
  'svPersonenData.personen.stammdaten.nationalitaet';
export const ITEM_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_NATIONALITAET = 'nationalitaet';
export const PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_JURISTISCHE_PERSON =
  'svPersonenData.personen.stammdaten.juristischePerson';
export const ITEM_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_JURISTISCHE_PERSON = 'juristischePerson';
export const PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_SOZVERSANSTALT =
  'svPersonenData.personen.stammdaten.sozversanstalt';
export const ITEM_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_SOZVERSANSTALT = 'sozversanstalt';
export const PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_MERKUR_EMPLOYEE =
  'svPersonenData.personen.stammdaten.merkurEmployee';
export const ITEM_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_MERKUR_EMPLOYEE = 'merkurEmployee';
export const PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_VERSICHERUNGSNUMMER =
  'svPersonenData.personen.stammdaten.versicherungsnummer';
export const ITEM_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_VERSICHERUNGSNUMMER = 'versicherungsnummer';
export const PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE = 'svPersonenData.personen.stammdaten.adresse';
export const ITEM_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE = 'adresse';
export const PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_STRASSE =
  'svPersonenData.personen.stammdaten.adresse.strasse';
export const ITEM_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_STRASSE = 'strasse';
export const PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_HAUSNR =
  'svPersonenData.personen.stammdaten.adresse.hausnr';
export const ITEM_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_HAUSNR = 'hausnr';
export const PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_IKZ = 'svPersonenData.personen.stammdaten.adresse.ikz';
export const ITEM_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_IKZ = 'ikz';
export const PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_ORT = 'svPersonenData.personen.stammdaten.adresse.ort';
export const ITEM_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_ORT = 'ort';
export const PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_PLZ = 'svPersonenData.personen.stammdaten.adresse.plz';
export const ITEM_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_PLZ = 'plz';
export const PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_SOZVERSANSTALT_NAME =
  'svPersonenData.personen.stammdaten.sozversanstaltName';
export const ITEM_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_SOZVERSANSTALT_NAME = 'sozversanstaltName';
export const PATH_SV_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN = 'svPersonenData.personen.personRollen';
export const ITEM_SV_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN = 'personRollen';
export const PATH_SV_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN_VN = 'svPersonenData.personen.personRollen.vn';
export const ITEM_SV_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN_VN = 'vn';
export const PATH_SV_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN_VN_2 = 'svPersonenData.personen.personRollen.vn2';
export const ITEM_SV_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN_VN_2 = 'vn2';
export const PATH_SV_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN_VP = 'svPersonenData.personen.personRollen.vp';
export const ITEM_SV_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN_VP = 'vp';
export const PATH_BESTANDS_RISKEN = 'bestandsRisken';
export const ITEM_BESTANDS_RISKEN = 'bestandsRisken';
export const PATH_BESTANDS_RISKEN_VS = 'bestandsRisken.vs';
export const ITEM_BESTANDS_RISKEN_VS = 'vs';
export const PATH_BESTANDS_RISKEN_PRAEMIE = 'bestandsRisken.praemie';
export const ITEM_BESTANDS_RISKEN_PRAEMIE = 'praemie';
export const PATH_BESTANDS_RISKEN_AUTO_VERLAENGERUNG = 'bestandsRisken.autoVerlaengerung';
export const ITEM_BESTANDS_RISKEN_AUTO_VERLAENGERUNG = 'autoVerlaengerung';
export const PATH_BESTANDS_RISKEN_ZAHLWEISE = 'bestandsRisken.zahlweise';
export const ITEM_BESTANDS_RISKEN_ZAHLWEISE = 'zahlweise';
export const PATH_BESTANDS_RISKEN_ZWEIGE = 'bestandsRisken.zweige';
export const ITEM_BESTANDS_RISKEN_ZWEIGE = 'zweige';
export const PATH_BESTANDS_RISKEN_ZWEIGE_KEY = 'bestandsRisken.zweige.key';
export const ITEM_BESTANDS_RISKEN_ZWEIGE_KEY = 'key';
export const PATH_BESTANDS_RISKEN_ZWEIGE_KBEZ = 'bestandsRisken.zweige.kbez';
export const ITEM_BESTANDS_RISKEN_ZWEIGE_KBEZ = 'kbez';
export const PATH_BESTANDS_RISKEN_ZWEIGE_BESCHREIBUNG = 'bestandsRisken.zweige.beschreibung';
export const ITEM_BESTANDS_RISKEN_ZWEIGE_BESCHREIBUNG = 'beschreibung';
export const PATH_BESTANDS_RISKEN_ZWEIGE_PRAEMIE = 'bestandsRisken.zweige.praemie';
export const ITEM_BESTANDS_RISKEN_ZWEIGE_PRAEMIE = 'praemie';
export const PATH_BESTANDS_RISKEN_ZWEIGE_JAHRES_NETTO_PRAEMIE = 'bestandsRisken.zweige.jahresNettoPraemie';
export const ITEM_BESTANDS_RISKEN_ZWEIGE_JAHRES_NETTO_PRAEMIE = 'jahresNettoPraemie';

import { ModelField, ModelGroup, ModelItemAccessor } from '@mng/model';

export class SvAngebotDataItemAccessor {
  constructor(public itemAccessor: ModelItemAccessor) {}

  getId(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_ID);
  }
  getModifiedDate(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_MODIFIED_DATE);
  }
  getVertragsAenderung(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAGS_AENDERUNG);
  }
  getVertragszustandPerDatum(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAGSZUSTAND_PER_DATUM);
  }
  getVertragsAenderungInitialisiert(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAGS_AENDERUNG_INITIALISIERT);
  }
  getIddBeratungDurchgefuehrt(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_IDD_BERATUNG_DURCHGEFUEHRT);
  }
  getVertragsNummer(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAGS_NUMMER);
  }
  getVersionsNummer(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERSIONS_NUMMER);
  }
  getVertragsAblaufDatum(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAGS_ABLAUF_DATUM);
  }
  getProdukt(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_PRODUKT);
  }
  getFzKonto(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_FZ_KONTO);
  }
  getFzKontoKonto(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_FZ_KONTO_KONTO);
  }
  getFzKontoKontoName(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_FZ_KONTO_KONTO_NAME);
  }
  getFzKontoExklusivAbberNr(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_FZ_KONTO_EXKLUSIV_ABBER_NR);
  }
  getFzKontoVerrechnungsart(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_FZ_KONTO_VERRECHNUNGSART);
  }
  getFzKontoBezeichnung(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_FZ_KONTO_BEZEICHNUNG);
  }
  getFzKontoGiltVon(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_FZ_KONTO_GILT_VON);
  }
  getFzKontoGiltBis(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_FZ_KONTO_GILT_BIS);
  }
  getFzKontoPersonalNummerRegex(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_FZ_KONTO_PERSONAL_NUMMER_REGEX);
  }
  getFzKontoPersonalNummerExplanation(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_FZ_KONTO_PERSONAL_NUMMER_EXPLANATION);
  }
  getFzKontoDienststelleRequired(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_FZ_KONTO_DIENSTSTELLE_REQUIRED);
  }
  getFzKontoPersNrErforderlich(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_FZ_KONTO_PERS_NR_ERFORDERLICH);
  }
  getBestandFzKontoNr(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_BESTAND_FZ_KONTO_NR);
  }
  getVermittlerInfo(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_SV_VERMITTLER_INFO);
  }
  getVermittlerInfoVermittlerNr(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_VERMITTLER_INFO_VERMITTLER_NR);
  }
  getVermittlerInfoVermittlerName(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_SV_VERMITTLER_INFO_VERMITTLER_NAME);
  }
  getVermittlerInfoVermittlerNameNachname(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_VERMITTLER_INFO_VERMITTLER_NAME_NACHNAME);
  }
  getVermittlerInfoVermittlerNameVorname(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_VERMITTLER_INFO_VERMITTLER_NAME_VORNAME);
  }
  getVermittlerInfoMakler(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_VERMITTLER_INFO_MAKLER);
  }
  getVermittlerInfoCourtage(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_VERMITTLER_INFO_COURTAGE);
  }
  getVermittlerInfoHasGv(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_VERMITTLER_INFO_HAS_GV);
  }
  getVermittlerInfoHasLv(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_VERMITTLER_INFO_HAS_LV);
  }
  getVermittlerInfoHasSv(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_VERMITTLER_INFO_HAS_SV);
  }
  getVermittlerInfoHasUv(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_VERMITTLER_INFO_HAS_UV);
  }
  getVermittlerInfoVseRequired(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_VERMITTLER_INFO_VSE_REQUIRED);
  }
  getVermittlerInfoKooperationspartner(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_VERMITTLER_INFO_KOOPERATIONSPARTNER);
  }
  getVermittlerInfoAbkommen(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_VERMITTLER_INFO_ABKOMMEN);
  }
  getVermittlerInfoAbberType(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_VERMITTLER_INFO_ABBER_TYPE);
  }
  getVermittlerInfoIsMaklerspitze(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_VERMITTLER_INFO_IS_MAKLERSPITZE);
  }
  getVermittlerInfoIsTeamPartnerSpitze(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_VERMITTLER_INFO_IS_TEAM_PARTNER_SPITZE);
  }
  getVermittlerInfoHasDisplayableSubordinates(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_VERMITTLER_INFO_HAS_DISPLAYABLE_SUBORDINATES);
  }
  getVermittlerInfoBlattAbber(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_SV_VERMITTLER_INFO_BLATT_ABBER);
  }
  getVermittlerInfoBlattAbberVermittlerNr(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_VERMITTLER_INFO_BLATT_ABBER_VERMITTLER_NR);
  }
  getVermittlerInfoBlattAbberVermittlerName(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_SV_VERMITTLER_INFO_BLATT_ABBER_VERMITTLER_NAME);
  }
  getVermittlerInfoBlattAbberVermittlerNameNachname(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_VERMITTLER_INFO_BLATT_ABBER_VERMITTLER_NAME_NACHNAME);
  }
  getVermittlerInfoBlattAbberVermittlerNameVorname(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_VERMITTLER_INFO_BLATT_ABBER_VERMITTLER_NAME_VORNAME);
  }
  getVermittlerInfoBlattAbberMakler(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_VERMITTLER_INFO_BLATT_ABBER_MAKLER);
  }
  getVermittlerInfoBlattAbberCourtage(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_VERMITTLER_INFO_BLATT_ABBER_COURTAGE);
  }
  getVermittlerInfoBlattAbberHasGv(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_VERMITTLER_INFO_BLATT_ABBER_HAS_GV);
  }
  getVermittlerInfoBlattAbberHasLv(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_VERMITTLER_INFO_BLATT_ABBER_HAS_LV);
  }
  getVermittlerInfoBlattAbberHasSv(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_VERMITTLER_INFO_BLATT_ABBER_HAS_SV);
  }
  getVermittlerInfoBlattAbberHasUv(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_VERMITTLER_INFO_BLATT_ABBER_HAS_UV);
  }
  getVermittlerInfoBlattAbberVseRequired(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_VERMITTLER_INFO_BLATT_ABBER_VSE_REQUIRED);
  }
  getVermittlerInfoBlattAbberKooperationspartner(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_VERMITTLER_INFO_BLATT_ABBER_KOOPERATIONSPARTNER);
  }
  getVermittlerInfoBlattAbberAbkommen(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_VERMITTLER_INFO_BLATT_ABBER_ABKOMMEN);
  }
  getVermittlerInfoBlattAbberAbberType(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_VERMITTLER_INFO_BLATT_ABBER_ABBER_TYPE);
  }
  getVermittlerInfoBlattAbberIsMaklerspitze(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_VERMITTLER_INFO_BLATT_ABBER_IS_MAKLERSPITZE);
  }
  getVermittlerInfoBlattAbberIsTeamPartnerSpitze(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_VERMITTLER_INFO_BLATT_ABBER_IS_TEAM_PARTNER_SPITZE);
  }
  getVermittlerInfoBlattAbberHasDisplayableSubordinates(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_VERMITTLER_INFO_BLATT_ABBER_HAS_DISPLAYABLE_SUBORDINATES);
  }
  getRisikoAdresseNotwendig(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_RISIKO_ADRESSE_NOTWENDIG);
  }
  getRisikoAdresse(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_RISIKO_ADRESSE);
  }
  getRisikoAdresseStrasse(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_RISIKO_ADRESSE_STRASSE);
  }
  getRisikoAdresseHausnr(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_RISIKO_ADRESSE_HAUSNR);
  }
  getRisikoAdresseIkz(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_RISIKO_ADRESSE_IKZ);
  }
  getRisikoAdresseOrt(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_RISIKO_ADRESSE_ORT);
  }
  getRisikoAdressePlz(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_RISIKO_ADRESSE_PLZ);
  }
  getRisikoAdresseCheckState(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_RISIKO_ADRESSE_CHECK_STATE);
  }
  getBeratungsdaten(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_BERATUNGSDATEN);
  }
  getBeratungsdatenProduktKategorie(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_BERATUNGSDATEN_PRODUKT_KATEGORIE);
  }
  getBeratungsdatenProduktNummer(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_BERATUNGSDATEN_PRODUKT_NUMMER);
  }
  getBeratungsdatenZweige(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_BERATUNGSDATEN_ZWEIGE);
  }
  getBeratungsdatenZweigeId(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_BERATUNGSDATEN_ZWEIGE_ID);
  }
  getBeratungsdatenZweigeLeistungsarten(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_BERATUNGSDATEN_ZWEIGE_LEISTUNGSARTEN);
  }
  getBeratungsdatenZweigeLeistungsartenId(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_BERATUNGSDATEN_ZWEIGE_LEISTUNGSARTEN_ID);
  }
  getSvPersonenData(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_SV_PERSONEN_DATA);
  }
  getSvPersonenDataPersonen(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_SV_PERSONEN_DATA_PERSONEN);
  }
  getSvPersonenDataPersonenId(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_PERSONEN_DATA_PERSONEN_ID);
  }
  getSvPersonenDataPersonenHauptwohnsitzOesterreich(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_PERSONEN_DATA_PERSONEN_HAUPTWOHNSITZ_OESTERREICH);
  }
  getSvPersonenDataPersonenStammdaten(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN);
  }
  getSvPersonenDataPersonenStammdatenPartnerNr(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_PARTNER_NR);
  }
  getSvPersonenDataPersonenStammdatenGeschlecht(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_GESCHLECHT);
  }
  getSvPersonenDataPersonenStammdatenVorname(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_VORNAME);
  }
  getSvPersonenDataPersonenStammdatenTitel(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_TITEL);
  }
  getSvPersonenDataPersonenStammdatenTitelNachgestellt(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_TITEL_NACHGESTELLT);
  }
  getSvPersonenDataPersonenStammdatenBerufstitel(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_BERUFSTITEL);
  }
  getSvPersonenDataPersonenStammdatenTimeStamp(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_TIME_STAMP);
  }
  getSvPersonenDataPersonenStammdatenName(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_NAME);
  }
  getSvPersonenDataPersonenStammdatenGebdatum(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_GEBDATUM);
  }
  getSvPersonenDataPersonenStammdatenFamilienstand(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_FAMILIENSTAND);
  }
  getSvPersonenDataPersonenStammdatenBerufsbezeichnung(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_BERUFSBEZEICHNUNG);
  }
  getSvPersonenDataPersonenStammdatenBeschaeftigungsart(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_BESCHAEFTIGUNGSART);
  }
  getSvPersonenDataPersonenStammdatenBeschaeftigtBei(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_BESCHAEFTIGT_BEI);
  }
  getSvPersonenDataPersonenStammdatenGeburtsland(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_GEBURTSLAND);
  }
  getSvPersonenDataPersonenStammdatenNationalitaet(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_NATIONALITAET);
  }
  getSvPersonenDataPersonenStammdatenJuristischePerson(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_JURISTISCHE_PERSON);
  }
  getSvPersonenDataPersonenStammdatenSozversanstalt(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_SOZVERSANSTALT);
  }
  getSvPersonenDataPersonenStammdatenMerkurEmployee(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_MERKUR_EMPLOYEE);
  }
  getSvPersonenDataPersonenStammdatenVersicherungsnummer(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_VERSICHERUNGSNUMMER);
  }
  getSvPersonenDataPersonenStammdatenAdresse(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE);
  }
  getSvPersonenDataPersonenStammdatenAdresseStrasse(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_STRASSE);
  }
  getSvPersonenDataPersonenStammdatenAdresseHausnr(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_HAUSNR);
  }
  getSvPersonenDataPersonenStammdatenAdresseIkz(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_IKZ);
  }
  getSvPersonenDataPersonenStammdatenAdresseOrt(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_ORT);
  }
  getSvPersonenDataPersonenStammdatenAdressePlz(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_PLZ);
  }
  getSvPersonenDataPersonenStammdatenSozversanstaltName(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_PERSONEN_DATA_PERSONEN_STAMMDATEN_SOZVERSANSTALT_NAME);
  }
  getSvPersonenDataPersonenPersonRollen(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_SV_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN);
  }
  getSvPersonenDataPersonenPersonRollenVn(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN_VN);
  }
  getSvPersonenDataPersonenPersonRollenVn2(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN_VN_2);
  }
  getSvPersonenDataPersonenPersonRollenVp(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_SV_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN_VP);
  }
  getBestandsRisken(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_BESTANDS_RISKEN);
  }
  getBestandsRiskenVs(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_BESTANDS_RISKEN_VS);
  }
  getBestandsRiskenPraemie(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_BESTANDS_RISKEN_PRAEMIE);
  }
  getBestandsRiskenAutoVerlaengerung(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_BESTANDS_RISKEN_AUTO_VERLAENGERUNG);
  }
  getBestandsRiskenZahlweise(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_BESTANDS_RISKEN_ZAHLWEISE);
  }
  getBestandsRiskenZweige(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_BESTANDS_RISKEN_ZWEIGE);
  }
  getBestandsRiskenZweigeKey(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_BESTANDS_RISKEN_ZWEIGE_KEY);
  }
  getBestandsRiskenZweigeKbez(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_BESTANDS_RISKEN_ZWEIGE_KBEZ);
  }
  getBestandsRiskenZweigeBeschreibung(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_BESTANDS_RISKEN_ZWEIGE_BESCHREIBUNG);
  }
  getBestandsRiskenZweigePraemie(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_BESTANDS_RISKEN_ZWEIGE_PRAEMIE);
  }
  getBestandsRiskenZweigeJahresNettoPraemie(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_BESTANDS_RISKEN_ZWEIGE_JAHRES_NETTO_PRAEMIE);
  }
}
